import { CLASSES_OF_SERVICE_BY_TYPE, OLD_CLASSES_OF_SERVICE_BY_TYPE } from 'constants/classOfService';
import { common } from 'themes/rebrand';

export const getNewClassOfService = (classCode) =>
  Object.keys(CLASSES_OF_SERVICE_BY_TYPE)[Object.values(CLASSES_OF_SERVICE_BY_TYPE).findIndex((codes) => codes.includes(classCode))] ??
  classCode;

export const getOldClassOfService = (classCode) =>
  Object.keys(OLD_CLASSES_OF_SERVICE_BY_TYPE)[
    Object.values(OLD_CLASSES_OF_SERVICE_BY_TYPE).findIndex((codes) => codes.includes(classCode))
  ] ?? classCode;

export const getClassOfServiceColor = (classCode) => {
  if (!classCode) return null;
  const upperCode = classCode.toUpperCase();

  if (common.classes[upperCode]) {
    return common.classes[upperCode];
  }

  return null;
};

export const getClassOfServiceFontColor = (classCode) => {
  if (!classCode) return null;
  const upperCode = classCode.toUpperCase();

  if (common.searchResults?.header?.[upperCode]?.fontColour) {
    return common.searchResults.header[upperCode].fontColour;
  }

  return null;
};
